export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10687.7e1a6cc4.jpg";